
import { createMiddleware } from '../../../shared/redux';
import {
    getIbgeStatesLoadState,
    getIbgeStatesRequest,
    GET_IBGE_STATES,
} from './ibge.state';
import { isDataLoadingSucceeded } from '../../../shared/axios/axios.utils';

export const ibgeMiddlewares = createMiddleware({
    [GET_IBGE_STATES]: (state) => {
        if (isDataLoadingSucceeded(getIbgeStatesLoadState(state))) {
            return [];
        }
        return getIbgeStatesRequest();
    },
});
